module.exports = __webpack_public_path__ + "statics/img/home_topBtn.png";